var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSocialUnauthInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 12.5H16.25C14.1789 12.5 12.5 14.1789 12.5 16.25V23.75C12.5 25.8211 14.1789 27.5 16.25 27.5H23.75C25.8211 27.5 27.5 25.8211 27.5 23.75V16.25C27.5 14.1789 25.8211 12.5 23.75 12.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 19.5267C23.0923 20.1509 22.9857 20.7884 22.6951 21.3485C22.4045 21.9086 21.9446 22.3628 21.381 22.6465C20.8174 22.9302 20.1786 23.0289 19.5556 22.9287C18.9326 22.8285 18.3571 22.5343 17.9109 22.0881C17.4647 21.6419 17.1706 21.0664 17.0703 20.4434C16.9701 19.8204 17.0688 19.1817 17.3525 18.618C17.6362 18.0544 18.0904 17.5946 18.6505 17.3039C19.2106 17.0133 19.8481 16.9067 20.4723 16.9992C21.109 17.0937 21.6984 17.3903 22.1536 17.8455C22.6087 18.3006 22.9054 18.8901 22.9998 19.5267Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 15.875H24.1325",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialUnauthInstagram);
export default __webpack_public_path__ + "static/media/icon_social_unauth_instagram.0c38f7f91a57693e8f10c304d5dd152d.svg";
export { ForwardRef as ReactComponent };